import { CachedRequest } from "../api/cached_request.js";
import { getFriends } from "../api/requests/friends.requests.js";

const FRIENDS_CACHE_COOLDOWN_MS = 0;

export const FriendsCache = new CachedRequest( getFriends, FRIENDS_CACHE_COOLDOWN_MS );
